import Dragitems from './DragItems';
import { SIZE } from './constants';

export default Dragitems;
export { SIZE };